import React from 'react';
import{ isEmpty, get } from 'lodash';

//local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsStepFlow as WidgetsStepFlowView } from 'modules/widgetsStepFlow';
import { widgetsStepFlowPreloader as WidgetsStepFlowPreloader } from 'modules/widgetsStepFlow';
import { pageLevelSuccessAcknowledgement as PageLevelSuccessAcknowledgement } from 'ui/views/widgets/pageLevelSuccessAcknowledgement';

const _checkout = ( props ) => {

    if( isEmpty( get( props, 'successView', {} ) ) ) {

        return (
            <div className='ui-checkout'>
                <WidgetsStepFlowView
                    activeStepIndex={ props.currentStep - 1 }
                    steps={ props.steps }
                    requestPayload={ props.requestPayload }
                />
            </div>
        );
    } else {

        const { memberId, orderId, invoiceNumber, prescriptions, ...successViewData } = props.successView;

        return(

            <div className='ui-checkout'>
                <PageLevelSuccessAcknowledgement
                    { ...successViewData  }
                    onActionClick={ props.onSuccessfulCheckout }
                    message={ { memberId, orderId, invoiceNumber, prescriptions } }
                    type={ 'order' } />
            </div>
        );
    }
   
};

// set display name
_checkout.displayName = 'checkout';

// set default props
_checkout.defaultProps = {};

// prop types
_checkout.propTypes = {};

/*******************************/

// preloader view
const checkoutPreloader= () => {
    return (
        <div className='ui-checkout-preloader'>
            <WidgetsStepFlowPreloader />
        </div>
    );
};

// set display name
checkoutPreloader.displayName = 'checkoutPreloader';

// set default props
checkoutPreloader.defaultProps = {};

// prop types
checkoutPreloader.propTypes = {};

/*******************************/
/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { checkout as Checkout } from 'ui/views/widgets/checkout';
 *
 * // render
 * <Checkout propName='propValue'/>
 */
export const checkout = withNetworkState( checkoutPreloader, _checkout );
